// Config
export const ROOT_URL = 'https://lab.lectrum.io';
export const MAIN_URL = `${ROOT_URL}/redux/api`;
export const groupId = 'algroktvgc9z';
export const invite = 'MPYyoKWAl76z';
